import styled from "styled-components";

const WrapPosition = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  text {
    ${(props) => props.data.addStyle}

    ${(props) =>
      props.data.fontStyle &&
      props.data.fontStyle.family &&
      `font-family: ${props.data.fontStyle.family};`}

  ${(props) =>
      props.data.fontStyle &&
      props.data.fontStyle.size &&
      `font-size: ${props.data.fontStyle.size};`}
  
  ${(props) =>
      props.data.fontStyle &&
      props.data.fontStyle.limitStyle &&
      `@media (min-width:600px){
    ${props.data.fontStyle.limitStyle};
    `}
  }
`;

export { WrapPosition };



// WEBPACK FOOTER //
// ./src/components/preview/SvgTextItem.styled.tsx